import { merge } from '../../../../utils/state';
import { TYPES } from './actions';
import entity from '../../entities/jobCampaigns/entity';
import ReduxRestEntity from '../../../../utils/reduxRestEntity';

const coreReducer = entity.getReducer();

const INITIAL_STATE = {
  siteIds: {
    ...ReduxRestEntity.initialState,
    data: [],
  },
  nodes: {
    ...ReduxRestEntity.initialState,
    data: [],
  },
  filterOptions: {},
  sortOptions: {
    sort_field: 'start_date',
    desc_sort: 'true',
  },
  error: null,
  isLoading: false,
};

const reducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case TYPES.GET_SITE_IDS_REQUEST:
      return merge(state, {
        siteIds: merge(state.siteIds, {
          isLoading: true,
          error: null,
        }),
      });
    case TYPES.GET_SITE_IDS_FAILURE:
      return merge(state, {
        siteIds: merge(state.siteIds, {
          isLoading: false,
          error: action.payload,
        }),
      });
    case TYPES.GET_SITE_IDS_SUCCESS:
      return merge(state, {
        siteIds: merge(state.siteIds, {
          isLoading: false,
          data: action.payload.data,
        }),
      });
    case TYPES.GET_NODES_REQUEST:
      return merge(state, {
        nodes: merge(state.nodes, {
          isLoading: true,
          error: null,
        }),
      });
    case TYPES.GET_NODES_FAILURE:
      return merge(state, {
        nodes: merge(state.nodes, {
          isLoading: false,
          error: action.payload,
        }),
      });
    case TYPES.GET_NODES_SUCCESS:
      return merge(state, {
        nodes: merge(state.nodes, {
          isLoading: false,
          data: action.payload.data,
        }),
      });
    case TYPES.CLEAR_SITE_IDS:
      return merge(state, {
        siteIds: ReduxRestEntity.initialState,
      });
    case TYPES.UPDATE_FILTER_OPTIONS:
      return merge(state, {
        filterOptions: action.payload,
      });
    case TYPES.UPDATE_SEARCH_QUERY:
      return merge(state, {
        searchQuery: action.payload,
      });
    case TYPES.UPDATE_SORT_OPTIONS:
      return merge(state, {
        sortOptions: action.payload,
      });
    default:
      return coreReducer(state, action);
  }
};

export default reducer;
